import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import moment from "moment"
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService, MenuItem } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { DateFormatModel } from 'src/app/shared/models/common/date-format-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { TheraistAppointmentService } from 'src/app/shared/services/theraistappointment.service';
import {
  PatientSideBarInfo, TherapistAppointmentsByAppointmenType, TherapistAppointmentsForClinicRemoteResponseModel, TherapistAppointmentsForRoadHomeResponseModel,
  TherapistBlockAvailabilityData, TherapistAppointmentsWithNotAvailableSlots, breaks, blocks, notAvails, breakRoadshows, notAvailRoadshows
} from 'src/app/shared/models/response/appointment/therapist-appointment-by-appointment_type';
import { WIPStatesResponseModel } from 'src/app/shared/models/response/appointment/wip-states-response-model';
import { AppointmentUpdateStatusRequestModel } from 'src/app/shared/models/response/appointment/appointment-updatestatus-request-model';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { WipStatusBTmapping } from 'src/app/shared/models/common/wip-status';
import { BTSalesOrderUpdateRequestModel } from 'src/app/shared/models/request/salesorder-update-request-model-brightree';
import { FeatureGroupService } from 'src/app/shared/services/featuregroup.service';
import { MapDirectionsService, MapInfoWindow, MapMarker } from '@angular/google-maps';
import * as $ from 'jquery'
import { Constants } from 'src/app/shared/constants';
import { SettingsResponseModel } from 'src/app/shared/models/response/settings-response';
import { WeekViewMobileComponent } from '../week-view-mobile/week-view-mobile.component';
import { RCMCofigurationUrl } from 'src/app/shared/models/response/settings/settings-plugin-response-model';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { ExportAppointmentCount, SchedulerResponseModelForExport, SchedulerResponseModelForExportFinal } from 'src/app/shared/models/response/therapist/therapist-appointments-response-model';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { CancelVoidResponseModel } from 'src/app/shared/models/response/settings/settings-classificationtype-response-model';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/feature-flags';
import { WipStatusBtService } from 'src/app/services/wip-status-bt.service';
import { NavigationData } from 'src/app/admin/servicies/route-service.service';
import { NextBillionMarker } from 'src/app/shared/models/response/appointment/roadshow-timeslot-main-response-model';
import { MapComponent } from 'src/app/shared/map/map.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
@Component({
  selector: 'app-my-appointments-new',
  templateUrl: './my-appointments-new.component.html',
  styleUrls: ['./my-appointments-new.component.sass'],
  providers: [DialogService],
  standalone: false
})
export class MyAppointmentsNewComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow | undefined;
  @ViewChild('mapComponent') mapComponent: MapComponent;

  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();
  therapistAppointments: TherapistAppointmentsByAppointmenType;
  therapistClinicResult: TherapistAppointmentsForClinicRemoteResponseModel[];
  therapistRoadHomeResult: TherapistAppointmentsForRoadHomeResponseModel[];
  notAvailabilityDataOnApptDay: TherapistBlockAvailabilityData[];
  therapistAppointmentsWithNotAvailableSlots: TherapistAppointmentsWithNotAvailableSlots[];
  salesOrderStatus: WIPStatesResponseModel[];
  salesOrderStatusClinic: WIPStatesResponseModel[];
  salesOrderStatusRoad: WIPStatesResponseModel[];
  wipStatusBTMappingResponseModel: WipStatusBTmapping[];
  @Output() wipsStatusCreated = new EventEmitter<{ appWipStatus: string, schAppointmentId: number }>();

  status: { name: string; code: string; }[];
  ViewonMap: boolean = false;
  appointmentDetail: boolean = false;
  patientDetailSidebar: boolean = false;
  weekViewMobile: boolean = false;

  en: any;
  primeFormat: string = '';
  appDateFormat: DateFormatModel;
  therapistId: number;
  therapistName: string;
  facilityTimeZone: string = '';
  totalMiles: string = '';
  totalHours: string = ''
  salesOrderType: string = 'AppointmentRequest';
  selectedStatusClinic: WIPStatesResponseModel;
  selectedStatusRoad: WIPStatesResponseModel;
  therapistDefaultLocation: string = '';
  appointmentRoadHomeDetail: TherapistAppointmentsForRoadHomeResponseModel;
  startLocation: string = ''
  nextLocation: string = ''
  startLocationAddress: string = ''
  therapiststartLocationAddress: string = ''
  nextLocationAddress: string = ''
  center: google.maps.LatLngLiteral;
  //circleCenter: google.maps.LatLngLiteral;
  //radius: number;
  allPatientMarker = [];
  markers = [];
  infoContent = ''
  display: any;
  latitude: number;
  longitude: number;
  isChildWipStatusUpdated: boolean = false;
  childAppointmentID: number;
  salesOrderBrighttreeURL: any;
  brightreeInternalUserId: number;
  patientBrighttreeURL: any;
  exportDataRes: SchedulerResponseModelForExport[];
  exportAppointmentCnt: ExportAppointmentCount[];
  previousDate: string;
  private geoCoder;
  directionsResults: Observable<google.maps.DirectionsResult | undefined>;
  options: google.maps.MapOptions = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: true,
    maxZoom: 19,
    minZoom: 5,
  };
  rendererOptions: google.maps.DirectionsRendererOptions = {
    suppressMarkers: true,
  };
  infoWindowOptions: google.maps.InfoWindowOptions = {
    maxWidth: 245
  }
  zoom = 19;
  clinicCount: number = 0;
  roadCount: number = 0;
  gridId: number = 0;
  salesOrderId: number = 0;
  patientSidebar: PatientSideBarInfo;

  selectedCity: any;
  timeZone: { name: string; code: string; }[];
  AppointmentsType: { name: string; code: string; }[];

  ClinicRemoteStatus: boolean = false;
  HomeVisitStatus: boolean = false;
  canUpdateStatue: boolean
  isStatusUpdated: boolean = false;
  displayStatus: string;
  AppointmentStatusUpdate: boolean;
  appointmentNote: string;
  isBrightreeSystemAppUpdate: Boolean = true;
  isBrightreeSystemAppUpdateSetting: Boolean = false;
  therapistFacilityName: string;
  exportTherapistName: string;
  isFutureAppt: boolean = false;
  block: { disaplyDate: Date; start: string; end: string; isRoadshow: boolean; description: string; }[];
  break: { disaplyDate: Date; start: string; end: string; isRoadshow: boolean; description: string }[];
  notAvail: { disaplyDate: Date; start: string; end: string; isRoadshow: boolean; description: string; }[];
  blockRoadshow: { disaplyDate: Date; start: string; end: string; isRoadshow: boolean; description: string; }[];
  breakRoadshow: { disaplyDate: Date; start: string; end: string; isRoadshow: boolean; description: string }[];
  notAvailRoadshow: { disaplyDate: Date; start: string; end: string; isRoadshow: boolean; description: string; }[];
  breakCount: number = 0;
  blockCount: number = 0;
  notAvailCount: number = 0;
  breakRoadshowCount: number = 0;
  blockRoadshowCount: number = 0;
  notAvailRoadshowCount: number = 0;
  clinicRemoteApptCount: number = 0;
  roadHomeApptCount: number = 0;
  testDate: Date;
  therapistStart: string;
  therapistEnd: string;
  bHasAppintment: boolean = false;
  reason: CancelVoidResponseModel;
  reasonsResponseModel: CancelVoidResponseModel[];
  cancellationReasonsResponseModel: CancelVoidResponseModel[];
  voidReasonsResponseModel: CancelVoidResponseModel[];
  bDisaplyCancelVoidReason: boolean = false;
  calendarFullAppointmentStatus: boolean = false;
  points: NextBillionMarker[] = [];
  isGroupAppointmentFeatureSubscribed: boolean = false;
  //41466
  timeZoneList: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string }[];
  selectedPatientTimeZone: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string };
  // patientname: any;

  displayedClinicSlots: TherapistAppointmentsWithNotAvailableSlots[] = [];

  groupedAppointments: { [groupId: number]: TherapistAppointmentsForClinicRemoteResponseModel[] } = {};
  selectedGroupPatient: { [groupId: number]: TherapistAppointmentsForClinicRemoteResponseModel } = {};
  constructor(
    private webStorageService: WebStorageService,
    private router: Router,
    private theraistAppointmentService: TheraistAppointmentService,
    protected cdr: ChangeDetectorRef,
    private featureGroupService: FeatureGroupService,
    messageService: MessageService,
    private http: HttpClient,
    private dialougeService: DialogService,
    private mapDirectionsService: MapDirectionsService,
    private featureFlagService: FeatureFlagService,
    private settingsService: AdminSettingsService,
    private authenticationService: AuthenticationService, 
    private wipStatusBtService: WipStatusBtService) {
    super(messageService);
    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.brightreeInternalUserId = loggedInUser.crmBrightreeUserId;
    this.appDateFormat = this.webStorageService.getDateFormat();
    this.loading = false;
    this.status = [
      { name: 'In-progress', code: 'NY' },
      { name: 'Complete', code: 'RM' },
    ];

    this.timeZone = [
      { name: 'EST', code: 'NY' },
      { name: 'CST', code: 'RM' }
    ];

    this.AppointmentsType = [
      { name: 'All Appointments', code: 'NY' },
      { name: 'Clinic Visit', code: 'RM' },
      { name: 'Remote Setup', code: 'LDN' },
      { name: 'Home Visit', code: 'IST' }
    ];
    this.featureFlagService.getFeatureFlag(FeatureFlags.CalendarFullAppointmentStatus).subscribe(x => {
      this.calendarFullAppointmentStatus = x.responseModel.isEnabled;
    });


    const clientConfig = this.webStorageService.getClientConfig();
    if (clientConfig) {
      this.isGroupAppointmentFeatureSubscribed = clientConfig.isGroupAppointment
        ? clientConfig.isGroupAppointment
        : false;
    }
  }
  viewDate = new Date();
  //timeZoneList: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string }[];
  selectedTimeZone: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string };


  @ViewChild(WeekViewMobileComponent, { static: false }) childRef: WeekViewMobileComponent;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  ngOnInit() {
    this.timeZoneList = [
      //{ name: 'Indian Standard Time (UTC +5:30)', code: 'UTC +5:30', shortName: 'IST', orgcode: 'UTC+5', displayName: 'IST', countryName: 'Asia/Kolkata' },
      { name: 'Eastern Time (UTC -5:00)', code: 'UTC -5', shortName: 'EST', orgcode: 'UTC-5', displayName: 'EST', countryName: 'America/New_York' },
      { name: 'Central Time (UTC -6:00)', code: 'UTC -6', shortName: 'CST', orgcode: 'UTC-6', displayName: 'Central', countryName: 'America/Chicago' },
      { name: 'Mountain Time (UTC -7:00)', code: 'UTC -7', shortName: 'MST', orgcode: 'UTC-7', displayName: 'Mountain', countryName: 'America/Boise' },
      { name: 'Arizona Mountain Time (UTC-7:00)', code: 'UMST -7', orgcode: 'UMST-7', shortName: 'AMST', displayName: 'Mountain', countryName: 'America/Phoenix' },
      { name: 'Pacific Time (UTC -8:00)', code: 'UTC -8', shortName: 'PST', orgcode: 'UTC-8', displayName: 'Pacific', countryName: 'America/Los_Angeles' },
      { name: 'Hawaiian Standard Time (UTC -10:00)', code: 'UTC -10', orgcode: 'UTC-10', shortName: 'HST', displayName: 'Hawaiian', countryName: 'Pacific/Honolulu' }
    ];
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      this.therapistId = currentUserToken.userId;
      this.therapistName = currentUserToken.userFullName;
      this.facilityTimeZone = currentUserToken.crmTimeZone;
    }
    else {
      this.therapistId = 0;
      this.therapistName = '';
      this.facilityTimeZone = 'EST';
    }
    this.GetRCMConfigurationUrl();
    this.getUpdateStatusPermission();
    this.setCurrentLocation();
    this.appointmentRoadHomeDetail = new TherapistAppointmentsForRoadHomeResponseModel();
    this.therapistRoadHomeResult = [];
    this.therapistClinicResult = [];
    this.notAvailabilityDataOnApptDay = [];
    this.exportData1(true);
    setTimeout(() => {
      this.getSalesOrderStatus();
    }, 1000);
    this.GetAppointmentAndNotAvailableSlots();
    this.getWipStatusBTmapping();
    this.getCancelVoidReasons();



    $(function () {
      $('.open-mobile-calendar').on('click', function () {
        $('.calendar-modalbox').fadeIn('fast').addClass('open');
      });

      $('.close-mobile-calendar').on('click', function () {
        $('.calendar-modalbox').slideUp().removeClass('open');
      });
    });
    //this.exportPDF();
  }



  ngOnDestroy() {
    this.onDestroy.next();
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
    if (this.progress)
      this.progress.complete();
  }

  async getTherapistAppointment() {
    this.totalMiles = '';
    this.totalHours = '';
    this.loading = true;
    await this.theraistAppointmentService.GetTherapistScheduledAppointment(this.therapistId, this.viewDate.toDateString())
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .toPromise()
      .then((result) => {
        this.processResult<TherapistAppointmentsByAppointmenType>(result, () => {
          if (result.responseModel) {
            this.therapistAppointments = result.responseModel;
            this.therapistClinicResult = this.therapistAppointments.therapistAppointmentsForClinicRemoteResponseModels;
            this.therapistRoadHomeResult = this.therapistAppointments.therapistAppointmentsForRoadHomeResponseModels;
            this.clinicCount = this.therapistClinicResult.length;
            this.roadCount = this.therapistRoadHomeResult.length;

            if (this.therapistClinicResult.length > 0) {
              for (let i = 0; i < this.therapistClinicResult.length; i++) {
                let apphours = Math.floor(parseInt(this.therapistClinicResult[i].appointmentDuration) / 60);
                let appMinutes = parseInt(this.therapistClinicResult[i].appointmentDuration) % 60;
                let appTotalHours = (apphours > 0 ? (apphours + 'h ') : '') + (appMinutes > 0 ? (appMinutes + 'm') : '')
                this.therapistClinicResult[i].appointmentDuration = appTotalHours;
              }
            }

            if (this.therapistRoadHomeResult.length > 0) {
              for (let i = 0; i < this.therapistRoadHomeResult.length; i++) {
                let rowHours = Math.floor(parseInt(this.therapistRoadHomeResult[i].duration) / 60);
                let rowMinutes = parseInt(this.therapistRoadHomeResult[i].duration) % 60;
                let rowTotalHours = rowHours + 'h ' + rowMinutes + 'm'
                this.therapistRoadHomeResult[i].duration = rowTotalHours;

                let apphours = Math.floor(parseInt(this.therapistRoadHomeResult[i].appointmentDuration) / 60);
                let appMinutes = parseInt(this.therapistRoadHomeResult[i].appointmentDuration) % 60;
                let appTotalHours = (apphours > 0 ? (apphours + 'h ') : '') + (appMinutes > 0 ? (appMinutes + 'm') : '')
                this.therapistRoadHomeResult[i].appointmentDuration = appTotalHours;
              }
              this.therapistFacilityName = this.therapistRoadHomeResult[0].facilityName;
              this.therapiststartLocationAddress = this.therapistRoadHomeResult[0].therapistAddress;
            }
            if (this.therapistRoadHomeResult.length > 1) {
              var lastIndex = this.therapistRoadHomeResult[this.therapistRoadHomeResult.length - 1];
              this.totalMiles = lastIndex.totalMiles.toString();
              let hours = Math.floor(lastIndex.totalETA / 60);
              let hoursMinutes = lastIndex.totalETA % 60;
              this.totalHours = hours + 'h ' + hoursMinutes + 'm'
              this.therapistDefaultLocation = lastIndex.therapistDefaultLocation;
            }
            else if (this.therapistRoadHomeResult.length == 1) {
              this.totalMiles = this.therapistRoadHomeResult[0].totalMiles.toString();
              let hours = Math.floor(this.therapistRoadHomeResult[0].totalETA / 60);
              let hoursMinutes = this.therapistRoadHomeResult[0].totalETA % 60;
              this.totalHours = hours + 'h ' + hoursMinutes + 'm'
              this.therapistDefaultLocation = this.therapistRoadHomeResult[0].therapistDefaultLocation;
            }
          }
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  async GetAllNotAvailableTherapistSlotByDate() {
    this.totalMiles = '';
    this.totalHours = '';
    this.loading = true;
    this.notAvailabilityDataOnApptDay = new Array<TherapistBlockAvailabilityData>();
    await this.theraistAppointmentService.GetAllNotAvailableTherapistSlotByDate(this.therapistId, this.viewDate.toDateString())
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .toPromise()
      .then((result) => {
        this.processResult<TherapistBlockAvailabilityData[]>(result, () => {
          if (result.responseModel) {
            this.notAvailabilityDataOnApptDay = [];
            this.notAvailabilityDataOnApptDay = result.responseModel;
          }
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  sortData() {

    return this.therapistAppointmentsWithNotAvailableSlots.sort((a, b) => {
      return <any>new Date(a.startTime) - <any>new Date(b.startTime);
    });
  }

  async GetAppointmentAndNotAvailableSlots() {
    await this.getTherapistAppointment();
    await this.GetAllNotAvailableTherapistSlotByDate();
    console.log(this.notAvailabilityDataOnApptDay);
    this.block = [];
    this.break = [];
    this.notAvail = [];
    this.blockRoadshow = [];
    this.breakRoadshow = [];
    this.notAvailRoadshow = [];
    this.therapistAppointmentsWithNotAvailableSlots = [];
    if (this.notAvailabilityDataOnApptDay.length > 0) {

      this.notAvailabilityDataOnApptDay = this.notAvailabilityDataOnApptDay.sort((a, b) => Number(a.crmStartTime) - Number(b.crmStartTime));

      for (let i = 0; i < this.notAvailabilityDataOnApptDay.length; i++) {

        var disaplyDate = this.notAvailabilityDataOnApptDay[i].startDateTime;
        var type = this.notAvailabilityDataOnApptDay[i].availablityType.toLocaleLowerCase();
        if (!CommonFunctions.isNullOrEmpty(type)) {
          this.therapistStart = this.convertTo12HourFormat(this.notAvailabilityDataOnApptDay[i].crmAvailabilityStartTime);
          this.therapistEnd = this.convertTo12HourFormat(this.notAvailabilityDataOnApptDay[i].crmAvailabilityEndTime);
          var start = this.convertTo12HourFormat(this.notAvailabilityDataOnApptDay[i].crmStartTime);
          var end = this.convertTo12HourFormat(this.notAvailabilityDataOnApptDay[i].crmEndTime);
          var isRoadshow = this.notAvailabilityDataOnApptDay[i].isRoadshow == null ? false : this.notAvailabilityDataOnApptDay[i].isRoadshow == true ? true : false;
          if (isRoadshow == false && this.therapistRoadHomeResult.length > 0)
            isRoadshow = true;

          var description = this.notAvailabilityDataOnApptDay[i].crmDescription;
          if (!isRoadshow) {
            if (type == 'block')
              this.block.push({ disaplyDate, start, end, isRoadshow, description });
            else if (type == 'break')
              this.break.push({ disaplyDate, start, end, isRoadshow, description });
            else if (type == 'notavail') {
              this.notAvail.push({ disaplyDate, start, end, isRoadshow, description });
              this.notAvailRoadshow.push({ disaplyDate, start, end, isRoadshow, description });
            }
          }
          else {
            if (type == 'block')
              this.blockRoadshow.push({ disaplyDate, start, end, isRoadshow, description });
            else if (type == 'break')
              this.breakRoadshow.push({ disaplyDate, start, end, isRoadshow, description });
            else if (type == 'notavail')
              this.notAvailRoadshow.push({ disaplyDate, start, end, isRoadshow, description });
          }
        }
        else
          this.therapistStart = this.convertTo12HourFormat(this.notAvailabilityDataOnApptDay[i].crmAvailabilityStartTime);
        this.therapistEnd = this.convertTo12HourFormat(this.notAvailabilityDataOnApptDay[i].crmAvailabilityEndTime);
      }

    }
    this.filltherapistClinicResult();
    this.filltherapistRoadHomeResult();

    if (this.therapistAppointmentsWithNotAvailableSlots.length > 1)
      this.therapistAppointmentsWithNotAvailableSlots = this.sortData();

    this.breakCount = this.break.length;
    this.blockCount = this.block.length;
    this.breakRoadshowCount = this.breakRoadshow.length;
    this.blockRoadshowCount = this.blockRoadshow.length;
    this.notAvailRoadshowCount = this.notAvailRoadshow.length;
    this.clinicRemoteApptCount = this.therapistClinicResult.length;
    this.roadHomeApptCount = this.therapistRoadHomeResult.length;

    this.bHasAppintment = false;
    if (this.therapistClinicResult.length > 0 || this.therapistRoadHomeResult.length > 0)
      this.bHasAppintment = true;


  }

  filltherapistClinicResult() {
    this.groupedAppointments = {};
    this.selectedGroupPatient = {};

    if (this.therapistClinicResult.length > 0) {
      const grouped: { [groupId: number]: TherapistAppointmentsForClinicRemoteResponseModel[] } = {};
      const individual: TherapistAppointmentsForClinicRemoteResponseModel[] = [];

      for (const appt of this.therapistClinicResult) {
        if (appt.groupAppointmentId != null) {
          if (!grouped[appt.groupAppointmentId]) {
            grouped[appt.groupAppointmentId] = [];
          }
          grouped[appt.groupAppointmentId].push(appt);
        } else {
          individual.push(appt);
        }
      }

      this.groupedAppointments = grouped;

      for (const groupIdStr of Object.keys(grouped)) {
        const groupId = Number(groupIdStr);
        const patients = grouped[groupId];
        this.selectedGroupPatient[groupId] = patients[0];

        const clinicRemote = new TherapistAppointmentsForClinicRemoteResponseModel();
        Object.assign(clinicRemote, patients[0]);

        const appointmentSlot = new TherapistAppointmentsWithNotAvailableSlots();
        appointmentSlot.clinicRemote = clinicRemote;
        appointmentSlot.startTime = patients[0].startTime;
        appointmentSlot.type = "Apptmnt";
        appointmentSlot.isGrouped = true;
        appointmentSlot.groupAppointmentId = groupId;
        this.therapistAppointmentsWithNotAvailableSlots.push(appointmentSlot);
      }

      for (const appt of individual) {
        const clinicRemote = new TherapistAppointmentsForClinicRemoteResponseModel();
        Object.assign(clinicRemote, appt);

        const appointmentSlot = new TherapistAppointmentsWithNotAvailableSlots();
        appointmentSlot.clinicRemote = clinicRemote;
        appointmentSlot.startTime = appt.startTime;
        appointmentSlot.type = "Apptmnt";
        appointmentSlot.isGrouped = false;
        appointmentSlot.groupAppointmentId = null;
        this.therapistAppointmentsWithNotAvailableSlots.push(appointmentSlot);
      }
    }
    if (this.block.length > 0) {
      for (let i = 0; i < this.block.length; i++) {
        const bl = new blocks();
        Object.assign(bl, this.block[i]);
        const slot = new TherapistAppointmentsWithNotAvailableSlots();
        slot.block = bl;
        slot.startTime = this.block[i].disaplyDate;
        slot.type = "Block";
        this.therapistAppointmentsWithNotAvailableSlots.push(slot);
      }
    }
    if (this.break.length > 0) {
      for (let i = 0; i < this.break.length; i++) {
        const bl = new breaks();
        Object.assign(bl, this.break[i]);
        const slot = new TherapistAppointmentsWithNotAvailableSlots();
        slot.break = bl;
        slot.startTime = this.break[i].disaplyDate;
        slot.type = "Break";
        this.therapistAppointmentsWithNotAvailableSlots.push(slot);
      }
    }
    if (this.notAvail.length > 0) {
      for (let i = 0; i < this.notAvail.length; i++) {
        const bl = new notAvails();
        Object.assign(bl, this.notAvail[i]);
        const slot = new TherapistAppointmentsWithNotAvailableSlots();
        slot.notAvail = bl;
        slot.startTime = this.notAvail[i].disaplyDate;
        slot.type = "NotAvail";
        this.therapistAppointmentsWithNotAvailableSlots.push(slot);
      }
    }
  }

   getGroupPatients(groupId: number): TherapistAppointmentsForClinicRemoteResponseModel[] {
    return this.groupedAppointments[groupId] || [];
  }


  getGroupPatientNames(groupId: number): string {
    const patients = this.getGroupPatients(groupId);
    return patients.map(p => p.patientLastName + ', ' + p.patientFirstName).join('\n');
  }

  onGroupPatientChange(event: any, groupId: number, slot: TherapistAppointmentsWithNotAvailableSlots) {
    const selected = event.value as TherapistAppointmentsForClinicRemoteResponseModel;
    this.selectedGroupPatient[groupId] = selected;
    Object.assign(slot.clinicRemote, selected);
  }

  filltherapistRoadHomeResult() {

    if (this.therapistRoadHomeResult.length > 0) {
      for (let i = 0; i < this.therapistRoadHomeResult.length; i++) {
        const clinicRoadHome = new TherapistAppointmentsForRoadHomeResponseModel();
        Object.assign(clinicRoadHome, this.therapistRoadHomeResult[i]);

        const appointmentSlot = new TherapistAppointmentsWithNotAvailableSlots();
        appointmentSlot.roadHomeAppt = clinicRoadHome;
        appointmentSlot.startTime = this.therapistRoadHomeResult[i].startTime;
        appointmentSlot.type = "Apptmnt";
        this.therapistAppointmentsWithNotAvailableSlots.push(appointmentSlot);
      }
    }
    if (this.blockRoadshow.length > 0) {
      for (let i = 0; i < this.blockRoadshow.length; i++) {
        const bl = new blocks();
        Object.assign(bl, this.blockRoadshow[i]);
        const slot = new TherapistAppointmentsWithNotAvailableSlots();
        slot.blockRoadshow = bl;
        slot.startTime = this.blockRoadshow[i].disaplyDate;
        slot.type = "Block";
        this.therapistAppointmentsWithNotAvailableSlots.push(slot);
      }
    }
    if (this.breakRoadshow.length > 0) {
      for (let i = 0; i < this.breakRoadshow.length; i++) {
        const bl = new breaks();
        Object.assign(bl, this.breakRoadshow[i]);
        const slot = new TherapistAppointmentsWithNotAvailableSlots();
        slot.breakRoadshow = bl;
        slot.startTime = this.breakRoadshow[i].disaplyDate;
        slot.type = "Break";
        this.therapistAppointmentsWithNotAvailableSlots.push(slot);
      }
    }
    if (this.notAvailRoadshow.length > 0) {
      for (let i = 0; i < this.notAvailRoadshow.length; i++) {
        const bl = new notAvails();
        Object.assign(bl, this.notAvailRoadshow[i]);
        const slot = new TherapistAppointmentsWithNotAvailableSlots();
        slot.notAvailRoadshow = bl;
        slot.startTime = this.notAvailRoadshow[i].disaplyDate;
        slot.type = "NotAvail";
        this.therapistAppointmentsWithNotAvailableSlots.push(slot);
      }
    }
  }
  convertTo12HourFormat(time24) {
    const [hours, minutes, seconds] = time24.split(':').map(Number);
    const period = hours < 12 ? 'am' : 'pm';

    // Convert hours to 12hour format
    const hours12 = (hours % 12) || 12;

    // Formating time in to 12-hour format
    const formattedTime = `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;

    return formattedTime;
  }
  private getSalesOrderStatus() {
    this.progress.next(true);
    this.theraistAppointmentService.GetAllWIPStatesBySalesOrderType(this.salesOrderType)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<WIPStatesResponseModel[]>(result, () => {
          this.salesOrderStatus = result.responseModel;
          if (this.calendarFullAppointmentStatus == true) {
            this.salesOrderStatusClinic = this.salesOrderStatus.
              filter(x => x.wipStatesName.toLowerCase() == 'complete'
                || x.wipStatesName.toLowerCase() == 'no show'
                || x.wipStatesName.toLowerCase() == 'cancel'
                || x.wipStatesName.toLowerCase() == 'void'
                || x.wipStatesName.toLowerCase() == 'void review'
              );
          }
          else {
            this.salesOrderStatusClinic = this.salesOrderStatus.
              filter(x => x.wipStatesName.toLowerCase() == 'complete'
                || x.wipStatesName.toLowerCase() == 'no show');
          }
          this.salesOrderStatusRoad = this.salesOrderStatusClinic;
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  

  async getWipStatusBTmapping() {
    this.loading = true;
    this.wipStatusBtService.getMappings()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          this.wipStatusBTMappingResponseModel = result.responseModel;
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });

  }

  async onUpdateAppointment(AppoinmentId) {
    if (this.selectedStatusRoad.wipStatesId === undefined) {
      this.showWarningMessage("Please select appointment status.");
      return;
    }
    if (this.bDisaplyCancelVoidReason == true && this.reason?.salesOrderVoidReason == undefined) {
      this.showWarningMessage("Please select reason for status.");
      return;
    }
    if (!this.isStatusUpdated) {
      this.updateAppointmentStatus(AppoinmentId);
    }
    if (AppoinmentId > 0) {
      this.loading = true;
      let appointmentUpdateStatusRequestModel = new AppointmentUpdateStatusRequestModel();
      appointmentUpdateStatusRequestModel.SchAppointmentId = AppoinmentId;
      appointmentUpdateStatusRequestModel.SchComments = this.appointmentNote == undefined ? "" : this.appointmentNote;
      await this.theraistAppointmentService.UpdateAppointmentDetailComment(appointmentUpdateStatusRequestModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => { this.progress.next(false); this.loading = false; }))
        .toPromise()
        .then((result) => {
          this.processResult<boolean>(result, () => {
            if (result.responseModel) {
              this.exportData1(true);
              this.showSuccessMessage("Appointment status and note has been updated.");
              this.AppointmentStatusUpdate = false;
              this.appointmentNote = "";
            }

          });
        }).catch((httpResponseError) => {
          this.loading = false;
          this.showErrorMessage(httpResponseError.message);
        });
    }
  }
  onChange(event) {
    if (event.value) {
      this.reason = event.value;
    }
  }

  async getCancelVoidReasons() {
    this.loading = true;
    this.settingsService.getCancelVoidReasons()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          if (result.responseModel != undefined && result.responseModel != null) {
            this.reasonsResponseModel = result.responseModel;
            const myClonedArray = [];
            this.reasonsResponseModel.forEach(val => myClonedArray.push(Object.assign({}, val)));
            this.voidReasonsResponseModel = myClonedArray.filter(x => x.salesOrderReasonType === 'Void');
            this.cancellationReasonsResponseModel = myClonedArray.filter(x => x.salesOrderReasonType === 'Cancel');
          }
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  updateAppointmentStatus(AppoinmentId) {
    if (!this.selectedStatusRoad) {
      this.showWarningMessage("Please select appointment status.");
      return;
    }

    //this.wipStatus = selectedEvent.eventSalesOrderSelectedStatus.wipStatesName;
    let status = this.selectedStatusRoad;
    let appointmentRequestBT = new BTSalesOrderUpdateRequestModel();
    appointmentRequestBT.IsUpdateToBrightree = false;
    appointmentRequestBT.IsDeliveryNoteOverride = true;
    appointmentRequestBT.IsOrderNoteOverride = true;
    appointmentRequestBT.OrderNote = null;
    appointmentRequestBT.DeliveryNote = null;
    appointmentRequestBT.PractitionerName = null;
    appointmentRequestBT.PractitionerId = 0;
    appointmentRequestBT.DeliveryTechnicianId = 0;
    appointmentRequestBT.ScheduledDeliveryStartDateString = null;
    appointmentRequestBT.ScheduledDeliveryStartTimeString = null;
    appointmentRequestBT.ScheduledDeliveryStartDate = null;
    appointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
    appointmentRequestBT.WIPDateNeeded = moment().toDate();
    appointmentRequestBT.CrmModifiedBy = this.therapistId;
    let selectedWipStaus: WipStatusBTmapping;
    if (status.wipStatesName.toLowerCase() == 'complete') {
      this.displayStatus = 'Complete';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'complete');
    }
    else if (status.wipStatesName.toLowerCase() == 'no show') {
      this.displayStatus = 'No Show';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'noshow');
    }
    else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'cancel') {
      this.displayStatus = 'Cancel';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'cancel');
    }
    else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'void') {
      this.displayStatus = 'Void';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void');
    }
    else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'void review') {
      this.displayStatus = 'Void Review';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview');
    }
    if (selectedWipStaus) {
      appointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
      appointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
      appointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
      appointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
    }
    appointmentRequestBT.IsUpdateToBrightree = !this.isBrightreeSystemAppUpdate;
    let statusId = selectedWipStaus.crmWipstatusId;
    let appointmentUpdateStatus: AppointmentUpdateStatusRequestModel[] = new Array();
    let appointmentUpdateStatusRequestModel = new AppointmentUpdateStatusRequestModel();
    appointmentUpdateStatusRequestModel.SchAppointmentId = AppoinmentId;
    appointmentUpdateStatusRequestModel.SchAppointmentStatus = statusId;
    appointmentUpdateStatusRequestModel.CrmFacilityId = this.appointmentRoadHomeDetail.facilityId;
    appointmentUpdateStatusRequestModel.CrmTherapistId = this.appointmentRoadHomeDetail.therapistId;
    appointmentUpdateStatusRequestModel.modifiedByUserInfoId = this.appointmentRoadHomeDetail.therapistId;
    appointmentUpdateStatusRequestModel.salesOrderUpdateRequestModelBT = appointmentRequestBT;
    appointmentUpdateStatusRequestModel.isUpdateByTherapist = true;
    appointmentUpdateStatusRequestModel.TherapistName = this.therapistName;

    if (this.bDisaplyCancelVoidReason == true) {
      appointmentUpdateStatusRequestModel.SchComments = this.appointmentNote;
      appointmentUpdateStatusRequestModel.schCancelReason = this.reason?.salesOrderVoidReason;
    }

    appointmentUpdateStatus.push(appointmentUpdateStatusRequestModel);
    this.theraistAppointmentService.UpdateAppointmentStatus(appointmentUpdateStatus)
      .pipe(takeUntil(this.unsubscriber), finalize(() => { this.progress.next(false); }))
      .toPromise()
      .then((result) => {
        this.processResult<boolean>(result, () => {
          if (result.responseModel) {
            this.isStatusUpdated = true;
            this.exportData1(true);
            this.GetAppointmentAndNotAvailableSlots();
            this.wipsStatusCreated.emit({ appWipStatus: selectedWipStaus.crmWipstatusNameSa, schAppointmentId: AppoinmentId });
            //this.showSuccessMessage("Appointment status has been updated.");
            this.isStatusUpdated = true;
            this.cdr.detectChanges();
          }

        });
      }).catch((httpResponseError) => {

        this.showErrorMessage(httpResponseError.message);
      });


  }

  onAppointmentDetail(roadHome) {
    this.points = [];
    console.log(roadHome);
    this.startLocation = '';
    this.nextLocation = '';
    let startLat = '';
    let startLong = '';
    let patientMarker = [];
    let wayPoints = [];
    this.markers = [];
    this.setCurrentLocation();
    this.selectedStatusRoad = new WIPStatesResponseModel();
    if (roadHome) {

      let currentPatientOrder = roadHome.appointmentOrder;
      let nextPatient = this.therapistRoadHomeResult.find(x => x.appointmentOrder === currentPatientOrder + 1);
      let prevPatient = this.therapistRoadHomeResult.find(x => x.appointmentOrder === currentPatientOrder - 1);

      // Start Location Logic
      if (currentPatientOrder === 1) {
        // For first appointment, start from therapist location

        this.startLocation = this.therapistDefaultLocation;
        this.startLocationAddress = this.therapistRoadHomeResult[0].therapistAddress;
        this.points.push({
          latLong: this.therapistRoadHomeResult[0].therapistLat + ',' + this.therapistRoadHomeResult[0].therapistLong,
          patientName: this.therapistName,
          patientAddress: this.therapistRoadHomeResult[0].therapistAddress,
          originatedFromTherapist: true,
          therapistAddress: this.therapistRoadHomeResult[0].therapistAddress,
          isEndLocation: false,
          isForTherapistModule: true
        });
      } else if (prevPatient) {
        // For subsequent appointments, start from previous patient location

        this.startLocation = prevPatient.patientLastName + ', ' + prevPatient.patientFirstName;
        this.startLocationAddress = prevPatient.crmPatientAddress;
        this.points.push({
          latLong: prevPatient.crmPatientLat + ',' + prevPatient.crmPatientLong,
          patientName: prevPatient.patientLastName + ', ' + prevPatient.patientFirstName,
          patientAddress: prevPatient.crmPatientAddress,
          originatedFromTherapist: false,
          therapistAddress: prevPatient.crmPatientAddress,
          isEndLocation: false,
          isTargetPatient: false,
          isForTherapistModule: true
        });
      }

      // Current Patient Location (always present)
      this.points.push({
        latLong: roadHome.crmPatientLat + ',' + roadHome.crmPatientLong,
        patientName: roadHome.patientLastName + ', ' + roadHome.patientFirstName,
        patientAddress: roadHome.crmPatientAddress,
        originatedFromTherapist: false,
        therapistAddress: roadHome.crmPatientAddress,
        isEndLocation: false,
        isTargetPatient: true,
        isForTherapistModule: true
      });

      // End Location Logic
      if (nextPatient) {
        // If next patient exists, end at next patient location
        this.nextLocation = nextPatient.patientLastName + ', ' + nextPatient.patientFirstName;
        this.nextLocationAddress = nextPatient.crmPatientAddress;

        this.points.push({
          latLong: nextPatient.crmPatientLat + ',' + nextPatient.crmPatientLong,
          patientName: nextPatient.patientLastName + ', ' + nextPatient.patientFirstName,
          patientAddress: nextPatient.crmPatientAddress,
          originatedFromTherapist: false,
          therapistAddress: nextPatient.crmPatientAddress,
          isEndLocation: true,
          isTargetPatient: false,
          isForTherapistModule: true
        });
      } else {
        // If no next patient, end at therapist start location
        this.nextLocation = this.therapistName;
        this.nextLocationAddress = this.therapistRoadHomeResult[0].therapistAddress;

        this.points.push({
          latLong: this.therapistRoadHomeResult[0].therapistLat + ',' + this.therapistRoadHomeResult[0].therapistLong,
          patientName: this.therapistName,
          patientAddress: this.therapistRoadHomeResult[0].therapistAddress,
          originatedFromTherapist: false,
          therapistAddress: this.therapistRoadHomeResult[0].therapistAddress,
          isEndLocation: true,
          isForTherapistModule: true
        });
      }

      if (roadHome.schWIPStatus == "Complete") {
        this.isStatusUpdated = true;
        this.displayStatus = roadHome.schWIPStatus;
      }
      else if (roadHome.schWIPStatus == "No Show") {
        this.isStatusUpdated = true;
        this.displayStatus = "No Show";
      }
      else if (roadHome.schWIPStatus == "Booked") {
        this.isStatusUpdated = false;
        this.displayStatus = roadHome.schWIPStatus;
      }
      else {
        this.isStatusUpdated = false;
        this.displayStatus = "";
      }

      this.appointmentRoadHomeDetail = roadHome;
    }
    this.appointmentDetail = true;
    this.points = [...this.points];
  }

  async WipStatusUpdatedOnSideBar(eventData: { appWipStatus: string, schAppointmentId: number }) {
    if (eventData) {
      // this.isChildWipStatusUpdated = true;
      // this.isStatusUpdated = true;
      // this.displayStatus = eventData.appWipStatus;
      // this.childAppointmentID = eventData.schAppointmentId;
      this.patientDetailSidebar = false;
      await this.GetAppointmentAndNotAvailableSlots();

    }
  }

  openInfoWindow(marker: MapMarker, content: string) {
    if (this.infoWindow != undefined) {
      this.infoContent = content
      this.infoWindow.open(marker)
    }
  }

  moveMap(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) this.center = (event.latLng.toJSON());
  }

  move(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) this.display = event.latLng.toJSON();
  }

  addAppintmentDetailMarker(patientDetail: any[]) {
    if (patientDetail.length > 0) {
      for (let i = 0; i < patientDetail.length; i++) {
        this.markers.push({
          position: patientDetail[i].position,
          icon: {
            url: patientDetail[i].url
          },
          info: patientDetail[i].address.toString(),
          options: {
            animation: google.maps.Animation.DROP,
          },
        });
      }
    }
  }

  addAllPatientMarker(patientDetail: any[]) {
    if (patientDetail.length > 0) {
      for (let i = 0; i < patientDetail.length; i++) {
        this.allPatientMarker.push({
          position: patientDetail[i].position,
          icon: {
            url: patientDetail[i].url
          },
          info: patientDetail[i].address.toString(),
          options: {
            animation: google.maps.Animation.DROP,
          },
        });
      }
    }
  }

  setDirection(originLat: number, originLong: number, destinationLat: number, destinationLong: number, waypts: any[]) {
    const request: google.maps.DirectionsRequest = {
      origin: {
        lat: Number(originLat),
        lng: Number(originLong)
      },
      destination: {
        lat: Number(destinationLat),
        lng: Number(destinationLong)
      },
      waypoints: waypts,
      travelMode: google.maps.TravelMode.DRIVING,
      optimizeWaypoints: true,
      provideRouteAlternatives: true,
    };
    this.directionsResults = this.mapDirectionsService.route(request).pipe(map(response => response.result));
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
  }

  clickedNavigator(destinationLat: string, destinationLong: string) {
    let origin = this.latitude + ',' + this.longitude;
    let destination = destinationLat + ',' + destinationLong;
    var url = 'https://www.google.com/maps/dir/?api=1&origin=' + origin + '&destination=' + destination + '&travelmode=driving';
    window.open(url);
  }

  viewAlldatainMap(value: boolean) {
    this.points = [];
    let patientMarker = [];
    this.allPatientMarker = [];
    let startLat = '';
    let startLong = '';
    let endLat = '';
    let endLong = '';
    let wayPoints = [];
    if (this.therapistRoadHomeResult.length > 0) {
      for (let i = 0; i < this.therapistRoadHomeResult.length; i++) {
        let lastIndexData = this.therapistRoadHomeResult[this.therapistRoadHomeResult.length - 1];
        if (lastIndexData.crmSalesorderAppId == this.therapistRoadHomeResult[i].crmSalesorderAppId) {
          patientMarker.push({
            position: ({
              lat: Number(this.therapistRoadHomeResult[i].crmPatientLat),
              lng: Number(this.therapistRoadHomeResult[i].crmPatientLong),
            }),
            address: '<h4 class="patient-name-location">' + this.therapistRoadHomeResult[i].patientLastName + ', ' + this.therapistRoadHomeResult[i].patientFirstName + '</h4>' + ' ' + this.therapistRoadHomeResult[i].crmPatientAddress,
            url: "assets/img/end-location-icon.svg"
          });

          this.points.push(
            {
              latLong: this.therapistRoadHomeResult[i].crmPatientLat + ',' + this.therapistRoadHomeResult[i].crmPatientLong,
              patientName: this.therapistRoadHomeResult[i].patientLastName + ', ' + this.therapistRoadHomeResult[i].patientFirstName,
              patientAddress: this.therapistRoadHomeResult[i].crmPatientAddress,
              originatedFromTherapist: false,
              therapistAddress: "",
              isEndLocation: true,
              isForTherapistModule: true

            }
          );

        }
        else {
          patientMarker.push({
            position: ({
              lat: Number(this.therapistRoadHomeResult[i].crmPatientLat),
              lng: Number(this.therapistRoadHomeResult[i].crmPatientLong),
            }),
            address: '<h4 class="patient-name-location">' + this.therapistRoadHomeResult[i].patientLastName + ', ' + this.therapistRoadHomeResult[i].patientFirstName + '</h4>' + ' ' + this.therapistRoadHomeResult[i].crmPatientAddress,
            url: "assets/img/patient-location.png"
          });

          this.points.push(
            {
              latLong: this.therapistRoadHomeResult[i].crmPatientLat + ',' + this.therapistRoadHomeResult[i].crmPatientLong,
              patientName: this.therapistRoadHomeResult[i].patientLastName + ', ' + this.therapistRoadHomeResult[i].patientFirstName,
              patientAddress: this.therapistRoadHomeResult[i].crmPatientAddress,
              originatedFromTherapist: false,
              therapistAddress: "",
              isEndLocation: false,
              isTargetPatient: false,
              isForTherapistModule: true,
              isPatientMarker: true
            }
          );

        }

        wayPoints.push({
          location: ({
            lat: Number(this.therapistRoadHomeResult[i].crmPatientLat),
            lng: Number(this.therapistRoadHomeResult[i].crmPatientLong),
          }),
          stopover: true
        });
      }
      patientMarker.push({
        position: ({
          lat: Number(this.therapistRoadHomeResult[0].therapistLat),
          lng: Number(this.therapistRoadHomeResult[0].therapistLong),
        }),
        address: '<h4 class="patient-name-location">' + this.therapistName + '</h4>' + ' ' + this.therapistRoadHomeResult[0].therapistAddress,
        url: "assets/img/therapist-location.png"
      });



      this.points.push(
        {
          latLong: this.therapistRoadHomeResult[0].therapistLat + ',' + this.therapistRoadHomeResult[0].therapistLong,
          patientName: this.therapistName,
          patientAddress: this.therapistRoadHomeResult[0].therapistAddress,
          originatedFromTherapist: true,
          therapistAddress: this.therapistRoadHomeResult[0].therapistAddress,
          isEndLocation: false,
          isTargetPatient: false,
          isForTherapistModule: true

        }
      );

    }
    let lastIndexData = this.therapistRoadHomeResult[this.therapistRoadHomeResult.length - 1];
    if (lastIndexData == undefined) {
      return;
    }
    startLat = this.therapistRoadHomeResult[0].therapistLat;
    startLong = this.therapistRoadHomeResult[0].therapistLong;
    endLat = lastIndexData.crmPatientLat;
    endLong = lastIndexData.crmPatientLong;
    // this.addAllPatientMarker(patientMarker);
    // this.setDirection(Number(startLat), Number(startLong), Number(endLat), Number(endLong), wayPoints);

    this.ViewonMap = value;

    this.points = [...this.points];
  }

  onMapSidebarShow(): void {
    this.mapComponent?.resize();
  }

  onPatientDetailSidebarClick(gridId, patientDetail) {
    this.patientDetailSidebar = true;
    this.patientSidebar = new PatientSideBarInfo();

    this.patientSidebar.patientName = patientDetail.patientLastName + ', ' + patientDetail.patientFirstName;
    this.patientSidebar.appointmentDate = patientDetail.startTime;
    this.patientSidebar.patientTimeZone = patientDetail.crmTimeZone;
    this.patientSidebar.visitType = gridId == 1 ? patientDetail.appointmentType : 'Road/Home Appt';
    this.patientSidebar.duration = patientDetail.appointmentDuration;
    this.patientSidebar.therapistID = this.therapistId;
    this.salesOrderId = patientDetail.crmSalesOrdeId;
    this.patientSidebar.status = patientDetail.schWIPStatus;
    this.patientSidebar.datetimeLastModified = patientDetail.dateTimeLastModified
  }

  ClinicRemoteclickEvent() {
    this.ClinicRemoteStatus = !this.ClinicRemoteStatus;
  }

  HomeVisitclickEvent() {
    this.HomeVisitStatus = !this.HomeVisitStatus;
  }

  private async getUpdateStatusPermission() {
    await this.featureGroupService.getSettings(Constants.SettingKeys.AllowTherapistToUpdateAppointmentStatus)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result) => {
        this.processResult<any>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.canUpdateStatue = (result.responseModel.schSettingValue.toLowerCase() === 'true');
              if (this.isAllowToSetNoShowStatus())
                this.isFutureAppt = true;
              else
                this.isFutureAppt = false;
            }
          }
        });
      });
  }
  destroyChild() {
    if (this.childRef) {
      this.childRef.ngOnDestroy();
    }
  }
  resetData() {
    this.weekViewMobile = false;
    this.destroyChild();
  }

  appointmentStatusDialog() {
    this.selectedStatusRoad = new WIPStatesResponseModel();
    this.AppointmentStatusUpdate = true;
  }

  onBTSelect(status: any) {

    if (status.checked) {
      this.isBrightreeSystemAppUpdate = true;
    }
    else {
      this.isBrightreeSystemAppUpdate = false;
    }
  }

  changeWipStatus(event: any) {
    this.selectedStatusRoad = event.value;
    let selectedWipStaus: WipStatusBTmapping;
    let result = [... this.salesOrderStatusRoad.filter(item => item.wipStatesName === this.selectedStatusRoad.wipStatesName)];
    if (result.length != null && result.length > 0) {

      if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'complete') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'complete');
      }
      else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'no show') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'noshow');
      }
      else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'cancel') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'cancel');
      }
      else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'void') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void');
      }
      else if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'void review') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview');
      }
      if (selectedWipStaus) {
        this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
        this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
      }
    }
    if ((this.selectedStatusRoad.wipStatesName.toLowerCase() == 'cancel') ||
      (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'void') ||
      (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'void review')) {

      this.bDisaplyCancelVoidReason = true;

      if (this.selectedStatusRoad.wipStatesName.toLowerCase() == 'cancel')
        this.reasonsResponseModel = this.cancellationReasonsResponseModel;
      else
        this.reasonsResponseModel = this.voidReasonsResponseModel;
    }

  }

  async GetRCMConfigurationUrl() {
    this.loading = true;
    this.settingsService.GetRCMConfigurationUrl(Constants.pluginSettingCRMApp)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<RCMCofigurationUrl>) => {
        this.processResult<RCMCofigurationUrl>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              let jsonData = result.responseModel;
              this.patientBrighttreeURL = jsonData.patientRCMURL;
              this.salesOrderBrighttreeURL = jsonData.salesOrderRCMURL;
            }
          }
        });
      }, (httpResponseError) => {

        this.showErrorMessage(httpResponseError.message);
      });

  }

  onNavigateBrightTreeSalesOrderUrl(crmSalesOrderAPPId: number) {
    let salesOrderUrl = this.salesOrderBrighttreeURL.replace("{{SalesOrderID}}", crmSalesOrderAPPId);
    salesOrderUrl = salesOrderUrl.replace("{{InternalUserID}}", this.brightreeInternalUserId);
    //console.log(salesOrderUrl);
    window.open(salesOrderUrl, '_blank')
  }

  onNavigateBrightTreePatientUrl(crmPatientId: number) {
    let patienKeyUrl = this.patientBrighttreeURL.replace("{{PatientKey}}", crmPatientId);
    patienKeyUrl = patienKeyUrl.replace("{{InternalUserID}}", this.brightreeInternalUserId);
    //console.log(patienKeyUrl);
    window.open(patienKeyUrl, '_blank')
  }

  async exportPDF() {
    await this.exportData1(true);
    setTimeout(() => {
      if (!this.exportDataRes) {
        this.showWarningMessage('No Appointments for selected Date.');
        return;
      }
      var data = document.getElementById('exportData');
      data.style["display"] = "block";
      html2canvas(data).then(canvas => {
        // Few necessary setting options
        var imgWidth = 208;
        var imgHeight = canvas.height * imgWidth / canvas.width;

        const contentDataURL = canvas.toDataURL('image/png')
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
        var position = 0;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
        pdf.save('My Appointments.pdf'); // Generated PDF
      });
      data.style["display"] = "none";
    }, 2000);

  }

  exportData1(isRefresh: boolean) {

    let therpistName = this.therapistName.split(/[ ,]+/).join(',');
    let splitName = therpistName.split(',');
    this.exportTherapistName = splitName[1] + ", " + splitName[0];

    if (this.previousDate == this.viewDate.toDateString()) {
      this.previousDate = this.viewDate.toDateString();
      return;
    }
    this.previousDate = this.viewDate.toDateString();
    this.theraistAppointmentService.GetTherapistAppointments(this.therapistId, this.viewDate.toDateString(), isRefresh)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<SchedulerResponseModelForExportFinal>(result, () => {
          //this.loading = false;
          if (result.responseModel.schedulerResponseModelForExportDbs != null) {
            var data = document.getElementById('exportData');
            data.style["display"] = "block";
            this.exportDataRes = result.responseModel.schedulerResponseModelForExportDbs;
            this.exportAppointmentCnt = result.responseModel.appointmentCountForExportPDFs;
            data.style["display"] = "none";
          }
        });
      }).catch((httpResponseError) => {
        //this.loading = false;
        this.showErrorMessage(httpResponseError.message);
      });
  }

  exportCSV() {
    if (!this.exportDataRes) {
      this.showWarningMessage('No Appointments for selected Date.');
      return;
    }
    if (this.loading)
      this.loading = false;
    this.loading = true;
    this.theraistAppointmentService.DownloadTherapistAppointmentsCSV(this.therapistId, this.viewDate.toDateString())
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: Blob) => {
        const downloadedFile = new Blob([result], { type: result.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        a.download = 'My Appointments.csv';
        document.body.appendChild(a);
        a.target = '_blank';
        a.href = URL.createObjectURL(downloadedFile);
        document.body.removeChild(a);
        a.click();
      }, (httpResponseMessage) => {
        this.showErrorMessage(this.getErrorMessage(httpResponseMessage));
      });
  }

  //41466
  isAllowToSetNoShowStatus(): boolean {
    var currentDateTime;
    var appDateTime;

    if (this.patientSidebar == undefined)
      return false;

    //41466: After marking No Show it allow user to change the availability of that therapist
    this.selectedPatientTimeZone = this.timeZoneList.find(x => x.orgcode == this.patientSidebar?.patientTimeZone);
    var orgappDateTime = moment.tz(this.patientSidebar?.appointmentDate, this.selectedPatientTimeZone.countryName);

    //convert appointment time to local timezone
    this.selectedPatientTimeZone = this.timeZoneList.find(x => x.code == this.appDateFormat.timeZone);
    var appDate = orgappDateTime.tz(this.selectedPatientTimeZone.countryName).format('DD-MMM-yyyy hh:mm:ss A');
    appDateTime = moment(appDate).toDate();

    // get curretn date time from local timezone
    var date = moment(new Date()).tz(this.selectedPatientTimeZone.countryName).format('DD-MMM-yyyy hh:mm:ss A');
    currentDateTime = moment(date).toDate();

    if (((appDateTime != undefined) && (currentDateTime != undefined)) && (appDateTime > currentDateTime))
      return true;

    return false;
  }
  onNavigationData(data: NavigationData) {

  }
}
